
import React from 'react';
import AddModifierGroups from './AddModifierGroups';
import DashboardLayout from '../../../components/Shop/RestaurantLayout/Layout/DashboardLayout';
import messages from '../../../locale/messages';

function action({ store, intl, params }) {
  const title = intl.formatMessage(messages.modifierGroup);

  let isRestaurantAuthenticated = store.getState().runtime.isRestaurantAuthenticated;

  if (!isRestaurantAuthenticated) {
    return { redirect: '/restaurant' };
  };

  return {
    title,
    component: (
      <DashboardLayout>
        <AddModifierGroups title={title} />
      </DashboardLayout>
    ),
  };
}

export default action;
